import SimpleReportActivity from "./SimpleReportActivity";
export default SimpleReportActivity;